<template>
  <v-list-tile
    @click="$emit('input', action)"
  >
    <v-list-tile-action>
      <v-icon v-text="action.icon ? action.icon : 'settings'"></v-icon>
    </v-list-tile-action>
    <v-list-tile-content>
      <v-list-tile-title v-text="translate(action.label)"></v-list-tile-title>
    </v-list-tile-content>
  </v-list-tile>
</template>

<script>
import { translateCandidates } from '@/utils';

export default {
  props: {
    action: Object,
  },
  methods: {
    translate(translatable) {
      return translateCandidates(
        [
          `message.${translatable}`,
          translatable,
        ],
        translatable,
      );
    },
  },
};
</script>
